import React from 'react'
import './App.css'
import { Redirect } from 'react-router-dom'
import { IoIosArrowBack } from 'react-icons/io'
import { IoMailOutline, IoCallOutline, IoPersonOutline } from 'react-icons/io5'
import { BiMenu } from 'react-icons/bi'
import Header5 from './components/Header5'
import Header from './layouts/Header'
import SideNav from './layouts/SideNav'
import SideNavCust from './layouts/SideNavCust'

// Match these to your SideNav CSS widths
const SIDEBAR_WIDTH = 240
const SIDEBAR_COLLAPSED_WIDTH = 72

const C = {
  ink: '#14213d',
  muted: '#6b7590',
  line: '#e6e9f2',
  track: '#eef1f8',
  blue: '#2f6fed',
}

const AVATARS = [
  ['#e8f0ff', '#2f6fed'],
  ['#efe6fb', '#8b3fd9'],
  ['#fff1dc', '#c77d0a'],
  ['#dcf5ec', '#0e8a5c'],
  ['#fde6e7', '#d13b40'],
]

const styles = `
@import url('https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600;700;800&display=swap');

.cp { font-family: 'Manrope', system-ui, -apple-system, 'Segoe UI', sans-serif; color: ${C.ink}; max-width: 720px; margin: 0 auto; padding: 8px 0 48px; }
.cp *, .cp *::before, .cp *::after { box-sizing: border-box; }
.cp h1, .cp h2, .cp p { margin: 0; }

.cp-back { display: inline-flex; align-items: center; gap: 4px; background: none; border: 0; padding: 4px 8px 4px 0; color: ${C.muted}; font: 600 14px/1 'Manrope', sans-serif; cursor: pointer; margin-top:40px}
.cp-back:hover { color: ${C.ink}; }
.cp-back:focus-visible, .cp a.cp-link:focus-visible { outline: 2px solid ${C.blue}; outline-offset: 2px; border-radius: 6px; }

.cp-card { background: #fff; border: 1px solid ${C.line}; border-radius: 14px; overflow: hidden; margin-top: 14px; }

.cp-hero { display: flex; align-items: center; gap: 18px; padding: 24px; border-bottom: 1px solid ${C.line}; }
.cp-av { flex: 0 0 auto; width: 68px; height: 68px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 24px; font-weight: 800; letter-spacing: .02em; }
.cp .cp-name { font-size: 24px; font-weight: 800; letter-spacing: -0.02em; line-height: 1.2; color: ${C.ink}; text-align: left; overflow-wrap: anywhere; }
.cp .cp-role { margin-top: 4px; font-size: 13.5px; font-weight: 600; color: ${C.muted}; }

.cp-sec { padding: 20px 24px 8px; font-size: 12.5px; font-weight: 700; color: ${C.muted}; text-transform: uppercase; letter-spacing: .06em; }

.cp-row { display: flex; align-items: center; gap: 14px; padding: 14px 24px; border-top: 1px solid ${C.line}; }
.cp-sec + .cp-row { border-top: 0; }
.cp-ic { flex: 0 0 auto; width: 38px; height: 38px; border-radius: 10px; background: ${C.track}; color: ${C.muted}; display: flex; align-items: center; justify-content: center; }
.cp-body { min-width: 0; }
.cp-label { font-size: 12.5px; font-weight: 600; color: ${C.muted}; }
.cp-val { margin-top: 2px; font-size: 15px; font-weight: 700; overflow-wrap: anywhere; }
.cp-val.empty { color: #9aa3b8; font-weight: 500; }
.cp a.cp-link { color: ${C.ink}; text-decoration: none; }
.cp a.cp-link:hover { color: ${C.blue}; text-decoration: underline; }
.cp-row:last-child { padding-bottom: 20px; }

@media (max-width: 560px) {
  .cp-hero { padding: 18px; gap: 14px; }
  .cp-av { width: 56px; height: 56px; font-size: 20px; }
  .cp .cp-name { font-size: 20px; }
  .cp-sec, .cp-row { padding-left: 18px; padding-right: 18px; }
}
`

const initialsOf = (name) => {
  const parts = String(name || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean)
  if (parts.length === 0) return '?'
  const first = parts[0].charAt(0)
  const last = parts.length > 1 ? parts[parts.length - 1].charAt(0) : ''
  return (first + last).toUpperCase()
}

const avatarColors = (name) => {
  const s = String(name || '')
  let h = 0
  for (let i = 0; i < s.length; i += 1) h = (h * 31 + s.charCodeAt(i)) % AVATARS.length
  return AVATARS[h]
}

class Customerprofile extends React.Component {
  constructor(props) {
    super(props)
    const isMobile = window.innerWidth <= 768

    this.state = {
      isMobile,
      collapsed: isMobile,
    }
  }

  componentDidMount() {
    this.updateIsMobile()
    window.addEventListener('resize', this.updateIsMobile)

    const customername = this.props.location.state.clientename
    document.title = customername + ' / Karamale'
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateIsMobile)
  }

  updateIsMobile = () => {
    const isMobile = window.innerWidth <= 768
    this.setState((prev) => ({
      isMobile,
      collapsed: isMobile ? true : prev.collapsed, // auto-collapse only when entering mobile
    }))
  }

  handleToggle = () => {
    this.setState((prevState) => ({
      collapsed: !prevState.collapsed,
    }))
  }

  render() {
    if (localStorage.getItem('businessname') === null) {
      return <Redirect to="/login" />
    }

    const customername = this.props.location.state.clientename
    const email = this.props.location.state.email
    const phone = this.props.location.state.phone

    const accounttype = localStorage.getItem('accounttype')
    const { collapsed, isMobile } = this.state

    const hasSidebar = accounttype === 'customer' || accounttype === 'business'
    const sidebarOffset =
      !hasSidebar || isMobile ? 0 : collapsed ? SIDEBAR_COLLAPSED_WIDTH : SIDEBAR_WIDTH
    const [bg, fg] = avatarColors(customername)

    return (
      <div className="view">
        <style>{styles}</style>

        {accounttype === 'customer' ? (
          <>
            <SideNavCust collapsed={collapsed} onToggle={this.handleToggle} />
            <Header />
          </>
        ) : accounttype === 'business' ? (
          <>
            <SideNav collapsed={collapsed} onToggle={this.handleToggle} />
            <Header />
          </>
        ) : (
          <Header5 />
        )}

        {hasSidebar && isMobile && !collapsed && (
          <div className="mobile-overlay active" onClick={this.handleToggle} />
        )}
        {hasSidebar && isMobile && collapsed && (
          <label className="mobile-toggle" onClick={this.handleToggle}>
            <BiMenu size={25} />
          </label>
        )}

        <div
          style={{
            marginTop: 48,
            marginLeft: sidebarOffset,
            width: `calc(100% - ${sidebarOffset}px)`,
            padding: '0 16px',
            transition: 'margin-left .25s ease, width .25s ease',
          }}
        >
          <div className="cp">
            <button type="button" className="cp-back" onClick={() => this.props.history.goBack()}>
              <IoIosArrowBack size={18} />
              Back
            </button>

            <div className="cp-card">
              <div className="cp-hero">
                <div className="cp-av" style={{ background: bg, color: fg }}>
                  {initialsOf(customername)}
                </div>
                <div>
                  <h1 className="cp-name">{customername}</h1>
                  <p className="cp-role">Customer</p>
                </div>
              </div>

              <div className="cp-sec">Contact details</div>

              <div className="cp-row">
                <span className="cp-ic">
                  <IoPersonOutline size={19} />
                </span>
                <div className="cp-body">
                  <div className="cp-label">Full name</div>
                  <div className={`cp-val ${customername ? '' : 'empty'}`}>
                    {customername || 'Not provided'}
                  </div>
                </div>
              </div>

              <div className="cp-row">
                <span className="cp-ic">
                  <IoMailOutline size={19} />
                </span>
                <div className="cp-body">
                  <div className="cp-label">Email</div>
                  <div className={`cp-val ${email ? '' : 'empty'}`}>
                    {email ? (
                      <a className="cp-link" href={`mailto:${email}`}>
                        {email}
                      </a>
                    ) : (
                      'Not provided'
                    )}
                  </div>
                </div>
              </div>

              <div className="cp-row">
                <span className="cp-ic">
                  <IoCallOutline size={19} />
                </span>
                <div className="cp-body">
                  <div className="cp-label">Phone number</div>
                  <div className={`cp-val ${phone ? '' : 'empty'}`}>
                    {phone ? (
                      <a className="cp-link" href={`tel:${phone}`}>
                        {phone}
                      </a>
                    ) : (
                      'Not provided'
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Customerprofile
